import React from 'react';
import BLHImgSpinner from '../assets/img/BLH-logo-spinner.gif';

export default function Spinner(props){
	return <>
		<div className={props.inCenter ? 'd-flex d-flex justify-content-center': ''}>
			<img src={BLHImgSpinner} alt="Loading..." width="40"/>
		</div>
	</>;
};